import React from 'react';
import { prop } from 'ramda';
import { Link } from 'js/components/common/Link';
import { Icon } from 'js/components/common/Icon';
import { languageService } from 'js/services/language.service';
import { useAppSelector, useUserSelector } from 'js/store/hooks';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import style from './Language.scss';

export const Language: React.FC = () => {
    const lang = useUserSelector(prop('lang'));
    const language = languageService.getTwoLetterLanguage(lang);
    const languagePage = useAppSelector(prop('languagePage'));
    const translate = useComponentTranslations();

    return languagePage
        ? (
            <Link
                href={languagePage}
                className={style.languageLink}
            >
                <Icon
                    type="headerLanguage"
                    className={`${style.icon} cms-icon-language`}
                    aria-label={translate('header.language.aria-label')}
                />
                <span className={style.language}>{language}</span>
            </Link>
        )
        : null;
};
